import { render, staticRenderFns } from "./ArtworkApprovalRequestForm.vue?vue&type=template&id=688a719f&scoped=true"
import script from "./ArtworkApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./ArtworkApprovalRequestForm.vue?vue&type=script&lang=js"
import style0 from "./ArtworkApprovalRequestForm.vue?vue&type=style&index=0&id=688a719f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688a719f",
  null
  
)

export default component.exports